// extracted by mini-css-extract-plugin
module.exports = {"toast":"alert_toast__2mjlz"};